import { Box, Typography } from "@mui/material";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";

// Shown when /restaurant/:id or /r/:slug resolves to nothing.
// Lives inside the same narrow vertical strip as the rest of the app
// (`--view-width`: 100vw on mobile, 460px on desktop) and fills it top-to-bottom.
const RestaurantNotFound = ({
    title = "Restaurant not found",
    message = "The restaurant you're looking for doesn't exist or is no longer available.",
}) => {
    return (
        <Box
            sx={{
                width: "var(--view-width)",
                minHeight: "100vh",
                margin: "0 auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#fafafa",
                padding: "24px",
                boxSizing: "border-box",
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    textAlign: "center",
                    backgroundColor: "#ffffff",
                    borderRadius: "12px",
                    padding: "32px 24px",
                    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
                    boxSizing: "border-box",
                }}
            >
                <Box
                    sx={{
                        width: 72,
                        height: 72,
                        borderRadius: "50%",
                        backgroundColor: "#fdecea",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto 16px",
                    }}
                >
                    <StorefrontOutlinedIcon
                        sx={{ fontSize: 40, color: "#c0392b" }}
                    />
                </Box>

                <Typography
                    sx={{
                        fontFamily: "Inter !important",
                        fontWeight: 600,
                        fontSize: "20px",
                        color: "#011C3A",
                        mb: 1,
                    }}
                >
                    {title}
                </Typography>

                <Typography
                    sx={{
                        fontFamily: "Inter !important",
                        fontWeight: 400,
                        fontSize: "14px",
                        color: "#5c6a7a",
                        lineHeight: 1.5,
                    }}
                >
                    {message}
                </Typography>
            </Box>
        </Box>
    );
};

export default RestaurantNotFound;
